if (process.env && process.env.NODE_ENV === "production") {
  __webpack_public_path__ = window.__webpack_public_path__;
}

import { picoapp } from "picoapp";
import { AppComponents } from "./AppComponents";
import common from "./features/common";
import webfonts from "./features/webfonts";
import icons from "./features/icons";

const app = picoapp(AppComponents);

window.theme_app = app;
window.theme_app.cdn = __webpack_public_path__;
app.mount(["data-component"]);

// Inside the Shopify Editor, remount updated sections
document.body.addEventListener("shopify:section:load", () => {
  app.mount(["data-component"]);
});

document.body.addEventListener("lazyload", () => {
  app.mount(["data-component"]);
});

common.init(app);
// webfonts.init();
icons.init();
